import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      dark: {
        primary: '#3f51b5',
        secondary: '#2196f3',
        accent: '#03a9f4',
        error: '#f44336',
        warning: '#ff5722',
        info: '#00bcd4',
        success: '#4caf50'
      }
    }
  }

})
